(function () {
  'use strict';

  function initialize(section) {
    if (section.dataset.careersInitialized) return;
    section.dataset.careersInitialized = 'true';
    var form = section.querySelector('.cb-careers__form');
    if (!form) return;
    var nameField = form.querySelector('input[name="contact[name]"]');
    var success = section.querySelector('[data-careers-success]');
    var message = success || section.querySelector('[data-careers-errors]');
    var draftKey = 'cb-careers-draft:' + window.location.pathname + ':' + form.id;
    // Never store or restore hidden role fields, Shopify form keys or CAPTCHA tokens.
    var fields = form.querySelectorAll('input[name^="contact["]:not([type="hidden"]), select[name^="contact["], textarea[name^="contact["]');
    var draftNote = form.querySelector('[data-careers-draft-note]');
    var status = form.querySelector('[data-careers-send-status]');
    var sendTimer;
    var storageAvailable = true;
    var restored = false;

    function clearDraft() {
      try { window.sessionStorage.removeItem(draftKey); } catch (error) { storageAvailable = false; }
    }

    function showDraftNote() {
      if (!draftNote) return;
      draftNote.hidden = false;
      draftNote.textContent = storageAvailable
        ? (restored ? 'Your previous answers were restored. Check for an earlier confirmation before sending again. ' : '') + 'Answers are saved in this tab for up to 30 minutes. Use Clear answers to remove them.'
        : 'This browser cannot save your answers if you leave the page. Use Copy your answers to keep a copy.';
    }

    function saveDraft() {
      if (success) return;
      var values = {};
      var hasAnswers = false;
      fields.forEach(function (field) {
        if (field.disabled) return;
        values[field.name] = field.value;
        if (field.value.trim()) hasAnswers = true;
      });
      try {
        if (hasAnswers) window.sessionStorage.setItem(draftKey, JSON.stringify({ createdAt: Date.now(), values: values }));
        else window.sessionStorage.removeItem(draftKey);
        storageAvailable = true;
      } catch (error) { storageAvailable = false; }
      showDraftNote();
    }

    function showStatus(text) {
      if (status) status.textContent = text;
    }

    if (success) {
      clearDraft();
    } else {
      try {
        var saved = JSON.parse(window.sessionStorage.getItem(draftKey));
        var age = saved && Date.now() - saved.createdAt;
        if (saved && typeof saved.createdAt === 'number' && age >= 0 && age < 30 * 60 * 1000 && saved.values && typeof saved.values === 'object') {
          fields.forEach(function (field) {
            if (Object.prototype.hasOwnProperty.call(saved.values, field.name) && typeof saved.values[field.name] === 'string') {
              field.value = saved.values[field.name].slice(0, field.maxLength > 0 ? field.maxLength : 4000);
              if (field.value.trim()) restored = true;
            }
          });
        } else {
          clearDraft();
        }
        // Check writes as well as reads; private browsing can permit only reads.
        window.sessionStorage.setItem(draftKey + ':check', '1');
        window.sessionStorage.removeItem(draftKey + ':check');
      } catch (error) {
        clearDraft();
        storageAvailable = false;
      }
      showDraftNote();
      form.addEventListener('input', function (event) {
        if (Array.prototype.indexOf.call(fields, event.target) !== -1) saveDraft();
      });
      form.addEventListener('change', saveDraft);
      form.addEventListener('invalid', function () {
        window.clearTimeout(sendTimer);
        showStatus('Please check the highlighted field before sending your application.');
      }, true);
      form.addEventListener('submit', function (event) {
        saveDraft();
        window.clearTimeout(sendTimer);
        if (navigator.onLine === false) {
          // Keep the answers on screen instead of navigating to a network-error page.
          event.preventDefault();
          event.stopPropagation();
          showStatus('You appear to be offline. Reconnect and try again, or copy your answers to email later.');
          return;
        }
        showStatus('Sending your application… Please wait for confirmation.');
        // Shopify owns the native POST. Do not resubmit automatically or
        // claim success from this event; a slow request may already be accepted.
        sendTimer = window.setTimeout(function () {
          showStatus('Sending has not been confirmed. Copy your answers and email hello@colorfulbunch.com, or reload this page and try again.');
        }, 12000);
      });
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;
        window.clearTimeout(sendTimer);
        showStatus('Check whether you already received a confirmation before sending again. Your answers are still here.');
      });

      var recovery = form.querySelector('[data-careers-recovery]');
      var copyButton = form.querySelector('[data-careers-copy]');
      var clearButton = form.querySelector('[data-careers-clear]');
      var copyStatus = form.querySelector('[data-careers-copy-status]');
      var copyFallback = form.querySelector('[data-careers-copy-fallback]');
      var copyText = form.querySelector('[data-careers-copy-text]');
      if (recovery && copyButton && clearButton && copyStatus && copyFallback && copyText) {
        recovery.hidden = false;
        copyButton.addEventListener('click', function () {
          var lines = ['Colorful Bunch — Workshop & Studio Assistant application'];
          fields.forEach(function (field) {
            if (field.disabled || !field.value.trim()) return;
            var label = field.labels && field.labels[0];
            lines.push((label ? label.textContent.replace(/\s+/g, ' ').trim() : field.name) + ':\n' + field.value);
          });
          var text = lines.join('\n\n');
          function selectText() {
            copyText.value = text;
            copyFallback.hidden = false;
            copyStatus.textContent = 'Automatic copying is unavailable. Select and copy the text below, then email hello@colorfulbunch.com.';
            copyText.focus();
            copyText.select();
          }
          if (!navigator.clipboard || !navigator.clipboard.writeText) { selectText(); return; }
          navigator.clipboard.writeText(text).then(function () {
            copyStatus.textContent = 'Answers copied. Paste them into an email to hello@colorfulbunch.com. Copying does not send your application.';
          }).catch(selectText);
        });
        clearButton.addEventListener('click', function () {
          fields.forEach(function (field) { field.value = ''; });
          clearDraft();
          restored = false;
          window.clearTimeout(sendTimer);
          showStatus('Your answers have been cleared.');
          copyStatus.textContent = '';
          copyText.value = '';
          copyFallback.hidden = true;
          showDraftNote();
          if (nameField) nameField.focus();
        });
      }
    }

    if (nameField) {
      section.querySelectorAll('[data-careers-role]').forEach(function (link) {
        link.addEventListener('click', function () {
          window.requestAnimationFrame(function () { nameField.focus({ preventScroll: true }); });
        });
      });
    }
    if (message) {
      window.requestAnimationFrame(function () { message.focus({ preventScroll: true }); });
    }
  }

  document.querySelectorAll('[data-careers-section]').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-careers-section]').forEach(initialize);
  });
})();
